import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $failure, $requesting, $success } from "../form/action";
import { $processing, $done } from "services/activity/action";

export const MODULE = "Manifest";

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $get = ActionCreator.Async(MODULE, "Get", (payload) => {
  return async (dispatch) => {
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}/tms/manifest/driver`, payload)
      .then((response) => {
        dispatch($get.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return error;
      })
      .finally(() => dispatch($done($get.OPERATION)));
  };
});

export const $show = ActionCreator.Async(MODULE, "Show", (id) => {
  return async (dispatch) => {
    dispatch($processing($show.OPERATION));

    return await Rest.GET(`${API_URL}/tms/manifest/${id}/driver`)
      .then((response) => {
        dispatch($show.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return error;
      })
      .finally(() => dispatch($done($show.OPERATION)));
  };
});

export const $start = ActionCreator.Async(MODULE, "Start", (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/manifest/${id}/start`, payload)
      .then((response) => {
        dispatch($start.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return error;
      });
  };
});

export const $accept = ActionCreator.Async(MODULE, "Accept", (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/manifest/${id}/accept`, payload)
      .then((response) => {
        dispatch($accept.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return error;
      });
  };
});

export const $complete = ActionCreator.Async(
  MODULE,
  "Complete",
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(`${API_URL}/tms/manifest/${id}/complete`, payload)
        .then((response) => {
          dispatch($complete.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return error;
        });
    };
  }
);

export const $additional = ActionCreator.Async(
  MODULE,
  "Additional",
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.POST(
        `${API_URL}/tms/manifest/additional/${id}`,
        payload
      )
        .then((response) => {
          dispatch($additional.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return error;
        });
    };
  }
);

export const $getAdditional = ActionCreator.Async(
  MODULE,
  "Show.Additional",
  (id) => {
    return async (dispatch) => {
      dispatch($processing($getAdditional.OPERATION));

      return await Rest.GET(`${API_URL}/tms/manifest/additional/${id}/manifest`)
        .then((response) => {
          dispatch($getAdditional.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return error;
        })
        .finally(() => dispatch($done($getAdditional.OPERATION)));
    };
  }
);

export const $updateItem = ActionCreator.Async(
  MODULE,
  "Update.Item",
  (manifest_id, job_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/job/${job_id}/update-item`,
        payload
      )
        .then((response) => {
          dispatch($updateItem.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return error;
        });
    };
  }
);
